import React from "react";

import { Container } from "./styles";

function TextArea({
  label,
  id,
  value,
  handler,
  placeholder,
  mensagemErro,
  size,
  required,
}) {
  return (
    <Container>
      <label>{label}</label>
      <textarea
        id={id}
        value={value}
        onChange={handler}
        placeholder={placeholder}
        size={size}
        required={required}
      />
      <span>{mensagemErro}</span>
    </Container>
  );
}

export default TextArea;
